import DiscountButtons from 'components/Upsell/Buttons/Discount';
import { useFlow } from 'contexts/FlowContext';
import { useOneClick } from 'contexts/OneClickBuyContext';
import { convertCentsToBRL } from 'utils/currency';
import { DiscountBadgeSvg } from './DiscountBadgeSvg';
import { Badge, Container, Description, Popup, TextBlock, Title } from './styles';

export const Content = () => {
	const { upsellDiscount } = useFlow();
	const { currency } = useOneClick();

	if (!upsellDiscount) {
		return null;
	}

	const fixedValue = upsellDiscount.type === 'fixed'
		? convertCentsToBRL(upsellDiscount.fixed, currency)
		: undefined;

	return (
		<Container>
			<Popup>
				<Badge>
					<DiscountBadgeSvg
						variant={upsellDiscount.type}
						fixedValue={fixedValue}
						percentageValue={upsellDiscount.percentage}
						title={upsellDiscount.title}
					/>
				</Badge>
				<TextBlock>
					<Title>{upsellDiscount.title}</Title>
					<Description>{upsellDiscount.description}</Description>
				</TextBlock>
				<DiscountButtons />
			</Popup>
		</Container>
	);
};
